<template>
  <span>
    <p
      class="boss-table-title is-boss-only-pc"
      data-test="label-company-name"
    >{{ entryCompanyName }}</p>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <approached-summary
          :approached-summaries="approachedSummaries"
        />
      </div>
    </div>
    <div class="boss-layout-block is-boss-only-pc">
      <div class="boss-layout boss-layout-start">
        <pdf-download :entry-ids="[entryId]" />
        <div>
          <button
            data-test="button-print-preview"
            class="boss-button"
            @click="windowOpenPrintPreview"
          >
            <img
              src="../../assets/images/icon-print.svg"
              alt
            >
            <span>印刷</span>
          </button>
        </div>
      </div>
    </div>
    <applicant-detail-resume
      :resume="resume"
      :entry-company-name="entryCompanyName"
    />
    <applicant-detail-career-resume
      :entry-id="entryId"
      :entry-company-name="entryCompanyName"
      :resume-updated-at="resume.updatedDate"
      :experienced-occupations="experiencedOccupations"
      :experienced-businesses="experiencedBusinesses"
      :career="career"
      :skills="skills"
      :is-light-entry="isLightEntry"
      :is-casual-interview-reques="isCasualInterviewRequest"
      :skill-note="skillNote"
    />
    <div class="pega-flex-center">
      <button
        class="boss-button boss-button-fill display-inline-flex"
        data-test="remove-button"
        @click="doRemove"
      >この応募者情報を削除する（復活不可）</button>
    </div>
  </span>
</template>

<script>
import ApplicantDetailResume from '@/components/organisms/ApplicantDetailResume'
import ApplicantDetailCareerResume from '@/components/organisms/ApplicantDetailCareerResume'
import ApproachedSummary from '@/components/molecules/ApproachedSummary'
import PdfDownload from '@/components/atoms/PdfDownload'
import _ from 'lodash'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapGetters } from 'vuex'

export default {
  components: {
    ApplicantDetailResume,
    ApplicantDetailCareerResume,
    ApproachedSummary,
    PdfDownload
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    entryCompanyName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      resume: {},
      approachedSummaries: [],
      experiencedOccupations: [],
      experiencedBusinesses: [],
      career: {},
      skills: [],
      isLightEntry: false,
      isCasualInterviewRequest: false,
      skillNote: ''
    }
  },
  computed: {
    ...mapGetters([
      'skillsMaster'
    ])
  },
  watch: {
    entryId: {
      handler () {
        this.fetchAll()
      }
    },
    skillsMaster: {
      handler () {
        // skillsがskillsMasterに依存しているため、skillsMasterの変更毎にfetchSkillsを再実行する
        // ケース例: マスタ取得が間に合っていない場合にskillsが空になってしまう
        this.fetchSkills()
      }
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.fetchResume()
      this.fetchApproachedSummary()
      this.fetchExperiencedOccupations()
      this.fetchExperiencedBusinesses()
      this.fetchCareer()
      this.fetchEntryType()
      this.fetchSkills()
      this.fetchSkillNote()
    },
    fetchResume () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume`).then(response => {
        this.$set(this, 'resume', response.data)
      })
    },
    fetchApproachedSummary () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/approached_jobs`).then(response => {
        this.$set(this, 'approachedSummaries', response.data)
      })
    },
    fetchExperiencedOccupations () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume/experienced_occupations`).then(response => {
        this.$set(this, 'experiencedOccupations', response.data)
      })
    },
    fetchExperiencedBusinesses () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume/experienced_businesses`).then(response => {
        this.$set(this, 'experiencedBusinesses', response.data)
      })
    },
    fetchCareer () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume/career`).then(response => {
        this.$set(this, 'career', response.data)
      })
    },
    fetchEntryType () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}`).then(response => {
        this.$set(this, 'isLightEntry', _.get(response.data, 'isLightEntry', false))
        this.$set(this, 'isCasualInterviewRequest', _.get(response.data, 'isCasualInterviewRequest', {}))
      })
    },
    fetchSkills () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume/skills`).then(response => {
        this.$set(this, 'skills', _(response.data).map(o => {
          return _.assign(o, _.pick(_.find(parseHierarchicalObjects(this.skillsMaster), { id: o.id }), 'path'))
        }).value())
      })
    },
    fetchSkillNote () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/resume/skill_note`).then(response => {
        this.$set(this, 'skillNote', response.data)
      })
    },
    windowOpenPrintPreview () {
      const routeData = this.$router.resolve({ name: 'applicantPrintPreview', params: { entryId: this.entryId } })
      window.open(routeData.href, '_blank')
    },
    removeEntry () {
      return this.$http.secured.put(`/entry/view/entries/${this.entryId}/_closed`)
    },
    doRemove () {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeEntry() // 削除して
            .then(() => {
              this.$toasted.global.success({ message: '応募者情報を削除しました。' })
              this.$router.push({ name: 'applicantTop' })
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
